import React, { useState } from "react";
import { Alert, Button, Table } from "reactstrap";
import { toastContainer } from "../../../../utils/toast";
import { validateEmail } from "../../../../utils/validations";
import Select from "react-select/lib/Select";

export default function MapColumnStep({ rowData, gotToNextStep, setRowData }) {
  const [invalidUsersList, setInvalidUsersList] = useState([]);
  const [showInvalidUsers,setShowInvalidUsers] = useState(false)

  const fieldOptions = [
    { label: "First Name", value: "firstName" },
    { label: "Last Name", value: "lastName" },
    { label: "Email", value: "email" },
    { label: "Mobile Number", value: "mobileNumber" },
  ];

  const [matchedKeys, setmatchedKeys] = useState([]);

  const getFieldNameFromKey = (key) => {
    const keyData = fieldOptions.find((x) => x.value == key);

    if (keyData) {
      return keyData.label;
    } else {
      return null;
    }
  };

  const mapTableData = () => {
    const data = [...rowData].filter((x) =>
      ["firstName", "lastName", "email", "mobileNumber"].includes(x.selectedKey)
    );

    console.log(data)

    const emailObj = data.find((x) => x.selectedKey == "email");
    const mobileNumberObj = data.find((x) => x.selectedKey == "mobileNumber");
    const firstNameObj = data.find((x) => x.selectedKey == "firstName");
    const lastNameObj = data.find((x) => x.selectedKey == "lastName");

    let array =[]

    if(!mobileNumberObj){

      toastContainer("Csv should have mobile numbers of users, Please try again.","error")
      return
    }

      array = mobileNumberObj.data.map((item, index) => {
        return {
          firstName: firstNameObj ? firstNameObj.data[index] : undefined,
          lastName: lastNameObj ? lastNameObj.data[index] : undefined,
          email: emailObj ? emailObj.data[index]:undefined,
          mobileNumber: item && item.length ? item.trim() : item,
          role: "User",
        };
      });

    const cleanedData = array.filter(
      (x) => x.mobileNumber 
    );

    console.log({array,cleanedData})
    const invalidData = array.filter((x) =>
    !(x.mobileNumber)
    );

    setInvalidUsersList(invalidData);

    gotToNextStep(cleanedData,invalidData);
  };

  const handleCsvDataInputChange=(rowIndex,colIndex,value)=>{
     const mainData = [...rowData]
     if(mainData[rowIndex] && mainData[rowIndex].data && Array.isArray( mainData[rowIndex].data))
     mainData[rowIndex].data[colIndex] = value;
     setRowData(mainData)
  }
  return (
    <div>
    
      {" "}
      <div>
        <div className="my-3">{matchedKeys.length} columns matched</div>
        <div className="data-mapping-table">
          <div className="data-mapping-table-upload-row">
            {rowData.map((row, index) => {
              const matched = matchedKeys.includes(row.selectedKey);
              return (
                <div className="match-col-main-wrapper-col">
                  <div
                    className={`map-cols-header px-2 ${
                      matched ? "matched-sec-bg" : "unmatched-sec-bg"
                    }`}
                    style={{ height: "200px" }}
                  >
                    <div className="text-center font-weight-bold mb-2">
                      {getFieldNameFromKey(row.selectedKey)
                        ? getFieldNameFromKey(row.selectedKey)
                        : row.fieldName}
                    </div>
                    <Select
                      options={fieldOptions.map((x) => ({
                        ...x,
                        disabled: matchedKeys.includes(x.value),
                      }))}
                      value={row.selectedKey}
                      onChange={(val) => {
                        if (val && val.value) {
                          const value = val.value;

                          const matched = [...matchedKeys];

                          if (value == "mobileNumber") {
                            // setInviteViaSMS(false)
                            // phoneValuesPresent=false
                          }

                          matched.push(value);
                          setmatchedKeys(matched);
                          const data = [...rowData];
                          const extsting = data.find(
                            (x) => x.selectedKey == value
                          );
                          if (extsting) {
                            toastContainer(
                              "This column is already matched please unmatch previous & match again",
                              "error"
                            );
                          } else {
                            data[index].selectedKey = value;

                            setRowData(data);
                          }
                        }
                      }}
                    />

                    <div className="text-center mt-4">
                      {matched ? (
                        <span className="matched-column-txt">
                          (matched column)
                        </span>
                      ) : (
                        <span className="unmatched-column-txt">
                          (unmatched column)
                        </span>
                      )}

                      {matched ? (
                        <div className="text-center mt10">
                          <i
                            className="material-icons"
                            style={{ color: "#1EC4B4", fontSize: "30px" }}
                          >
                            check_circle
                          </i>
                        </div>
                      ) : null}

                      {matched ? (
                        <div className="text-center mt10">
                          <span
                            className="text-danger cursor-pointer"
                            onClick={() => {
                              const matched = [...matchedKeys].filter(
                                (x) => x != row.selectedKey
                              );

                              console.log("row --- ", row);
                              console.log("amtched --- ", matched);

                              if (row.selectedKey == "mobileNumber") {
                                // setInviteViaSMS(false)
                                // phoneValuesPresent=false
                              }

                              setmatchedKeys(matched);

                              const row_d = [...rowData];

                              row_d[index].selectedKey = "";

                              setRowData(row_d);
                            }}
                          >
                            Unmatch
                          </span>
                        </div>
                      ) : null}
                    </div>
                  </div>

                  <div className="mt-3">
                    {row.data.map((x,i) => (
                      <div className="map-cols-data"> <input type="text" className="input-no-border" value={x} onChange={(e)=>{
                        handleCsvDataInputChange(index,i,e.target.value)
                      }} /> </div>
                    ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <Button className="float-right mt-3" color="info" onClick={mapTableData}>
          Next
        </Button>
      </div>
    </div>
  );
}
